import React from 'react';

export const SignUpPage: React.FunctionComponent = () => {
    return <p>Not implemented</p>;
}